import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getFormInitialValues as rfGetFormInitialValues, getFormValues as rfGetFormValues, getFormSyncErrors, getFormMeta, getFormError } from 'redux-form';
export var getFormFieldInitialValue = function getFormFieldInitialValue(form, field) {
  return function (state) {
    return (rfGetFormInitialValues(form)(state) || {})[field];
  };
};
export var getFormValues = function getFormValues(form) {
  return function (state) {
    return rfGetFormValues(form)(state) || {};
  };
};
export var getFormFieldValue = function getFormFieldValue(form, field, defaultValue) {
  return function (state) {
    var value = getFormValues(form)(state)[field];
    return typeof value === 'undefined' ? defaultValue : value;
  };
};
export var augmentSubmitActionWithAdditionalData = function augmentSubmitActionWithAdditionalData(action, extraData) {
  return function (data, dispatch) {
    return action(_objectSpread({}, data, extraData), dispatch);
  };
};
export var getFormErrors = function getFormErrors(formName) {
  var getMainError = getFormError(formName);
  var getErrors = getFormSyncErrors(formName);
  var getMeta = getFormMeta(formName);
  return function (state) {
    var formError = getMainError(state);
    var errors = getErrors(state);

    if (!errors && !formError) {
      return;
    }

    if (formError) {
      return formError;
    }

    var meta = getMeta(state) || {};
    var erroredFields = Object.keys(errors);
    var touchedErrors = erroredFields.filter(function (field) {
      return meta[field] && meta[field].touched && errors[field];
    }).reduce(function (memo, field) {
      memo[field] = errors[field];
      return memo;
    }, {});
    return touchedErrors;
  };
};
export var getFirstError = function getFirstError(formName) {
  var getMainError = getFormError(formName);
  var getErrors = getFormSyncErrors(formName);
  var getMeta = getFormMeta(formName);
  return function (state) {
    var formError = getMainError(state);
    var errors = getErrors(state);

    if (!errors && !formError) {
      return;
    }

    if (formError) {
      return formError;
    }

    var meta = getMeta(state) || {};
    var erroredFields = Object.keys(errors);
    return errors[erroredFields.find(function (field) {
      return meta[field] && meta[field].touched;
    })];
  };
};